"use client"

import type React from "react"
import PaymentCallback from "../components/payment/PaymentCallback"
import ErrorBoundary from "../components/common/ErrorBoundary"
import SEOHead from "../components/common/SEOHead"

const PaymentCallbackPage: React.FC = () => {
  return (
    <ErrorBoundary>
      <SEOHead
        title="Payment Status | Anmol Furniture Bazaar"
        description="Payment verification in progress"
        keywords="payment, status, verification"
      />
      <PaymentCallback />
    </ErrorBoundary>
  )
}

export default PaymentCallbackPage
